import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import it from './locales/it.json';
import en from './locales/en.json';

i18next.use(initReactI18next).init({
  lng: 'it',
  debug: false,
  resources: {
    it: {
      translation:it
    },
    en: {
      translation:en
    }
  },
  // React fa già l'escape di tutto il testo (e nel progetto nessuna traduzione finisce in HTML
  // grezzo): con l'escape di i18next le date diventavano "07&#x2F;10&#x2F;2026" e un apostrofo
  // nei nomi "&#39;"
  interpolation: { escapeValue: false },
  // if you see an error like: "Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz"
  // set returnNull to false (and also in the i18next.d.ts options)
  // returnNull: false,
});

// Lo screen reader sceglie la pronuncia dall'attributo lang della pagina
document.documentElement.lang = i18next.language;
i18next.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
